import Home from "../containers/HomeTemplate/Home"

// all endpoints
const PATHS = {
  CHARA: {
    SEARCH: "/search/chara"
  },
  FRAME: {
    SEARCH: "/search/frame"
  },
  ICON: {
    SEARCH: "/search/icon"
  },
  PARTNER: {
    SEARCH: "/search/partner"
  },
  NAMEPLATE: {
    SEARCH: "/search/nameplate"
  },
  JACKET: {
    SEARCH: "/search/jacket"
  },
  FORUM: "/",
  SIGNUP: "/",
  LOGIN: "/",
  FORGOT_PASSWORD: "/",
  PROFILE: "/",
  NOTIFICATIONS: "/",
  SETTINGS: "/",
  LOGOUT: "/"
}

const routeHome = [
  {
    exact: true,
    path: "/",
    component: Home
  },
  {
    exact: false,
    path: PATHS.CHARA.SEARCH,
    component: Home
  },
  {
    exact: false,
    path: PATHS.FRAME.SEARCH,
    component: Home
  },
  {
    exact: false,
    path: PATHS.ICON.SEARCH,
    component: Home
  },
  {
    exact: false,
    path: PATHS.PARTNER.SEARCH,
    component: Home
  },
  {
    exact: false,
    path: PATHS.NAMEPLATE.SEARCH,
    component: Home
  },
  {
    exact: false,
    path: PATHS.JACKET.SEARCH,
    component: Home
  }
]

export { routeHome, PATHS }
